export const CAPABILITIES = Object.freeze({
  ASSISTANT_MONITOR: 'assistant.monitor_all',
  SERVER_CAPACITY_READ: 'server.capacity.read',
  SERVER_CAPACITY_WRITE: 'server.capacity.write'
})

export function hasCapability(userInfo, capability) {
  if (userInfo?.capabilities?.[capability] === true) return true
  return capability === CAPABILITIES.SERVER_CAPACITY_READ &&
    userInfo?.capabilities?.[CAPABILITIES.SERVER_CAPACITY_WRITE] === true
}

export function permissionSignature(userInfo) {
  if (!userInfo) return ''
  const permissionKeys = Array.isArray(userInfo.permission_keys) ? [...userInfo.permission_keys].sort() : []
  const capabilities = Object.entries(userInfo.capabilities || {})
    .sort(([left], [right]) => left.localeCompare(right))
  return JSON.stringify({ permissionKeys, capabilities })
}
